<template>
  <div class="stationSearch" :class="styleIndex">
    <el-input
      clearable
      placeholder=""
      v-model.trim="inputName"
      class="input-with-select">
      <!-- 前置选择器 -->
      <template #prepend>
        <el-select
          v-if="showRatioEdit"
          v-model="selectName"
          placeholder="站点名称"
          class="selectName">
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-select
          v-else
          v-model="selectName"
          placeholder="站点名称"
          class="selectName">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
      </template>
      <!-- 后置按钮 -->
      <template #append>
        <el-button
          icon="el-icon-search"
          class="primary"
          @click="search"/>
      </template>
    </el-input>
  </div>
</template>

<script>
import Api from '@/api'
export default {
  name: 'stationSearch',
  props: {
    selfAreaId: {
      type: String
    },
    showRatioEdit: {
      type: Boolean
    },
    styleIndex: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: [
        {
          value: '1',
          label: '站点名称'
        },
        {
          value: '2',
          label: '站点编号'
        },
        {
          value: '3', // 精确搜索
          label: '车辆编号'
        }, {
          value: '6', // 精确搜索
          label: '车牌编号'
        }
      ],
      options2: [
        {
          value: '1',
          label: '站点名称'
        },
        {
          value: '2',
          label: '站点编号'
        }
      ],
      selectName: '1',
      inputName: ''
    }
  },
  methods: {
    search(key) {
      if (!key) {
        return
      }
      const vm = this
      const params = {}
      if (key && (typeof key === 'string' || typeof key === 'number')) {
        // 来自外部的精确搜索
        this.selectName = '3'
        this.inputName = key
      }
      params.searchType = this.selectName
      params.search = this.inputName
      params.selfAreaId = this.selfAreaId
      Api.dashboardSearch(params).then((res) => {
        if (res.code === 200) {
          vm.$emit('search', res.data)
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    siteSearch(key) {
      const vm = this
      const params = {}
      if (key && (typeof key === 'string' || typeof key === 'number')) {
        // 来自外部的精确搜索
        this.selectName = '2'
        this.inputName = key
      }
      params.searchType = this.selectName
      params.search = this.inputName
      params.selfAreaId = this.selfAreaId
      Api.dashboardSearch(params).then((res) => {
        if (res.code === 200) {
          vm.$emit('search', res.data)
        } else {
          vm.$message.warning(res.message)
        }
      })
    },
    siteNameSearch(key) {
      const vm = this
      const params = {}
      if (key && (typeof key === 'string' || typeof key === 'number')) {
        // 来自外部的精确搜索
        this.selectName = '1'
        this.inputName = key
      }
      params.searchType = this.selectName
      params.search = this.inputName
      params.selfAreaId = this.selfAreaId
      Api.dashboardSearch(params).then((res) => {
        if (res.code === 200) {
          vm.$emit('search', res.data)
        } else {
          vm.$message.warning(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.stationSearch {
  &.dark {
    .input-with-select {
      width: 320px;
      background: #06101d;
      border-radius: 4px;
    }
    /deep/ .el-input-group__prepend {
      background: transparent;
      border-color: #00dada;
      color: #00dada;
      & + input.el-input__inner {
        background: transparent;
        border-color: #00dada;
        color: #00dada;
      }
    }
    /deep/ .el-input-group__append{
      border-color:#00dada;
    }
    .primary{
      background: #00DADA;
      border-radius: 0px 2px 2px 0px;
      color:#06101D;
      border-color:#00dada;
      padding: 10px ;
      /deep/ .el-icon-search{
        font-size: 20px;
      }
    }
    .selectName {
      width:100px;
      /deep/ .el-input--suffix .el-input__inner {
        padding-left: 8px;
        padding-right: 24px;
      }
      /deep/ .el-input__suffix {
        right: 0;
        .el-input__icon {
          color: #00dada;
        }
      }
    }
  }
  .selectName {
    width: 110px;
  }
  .input-with-select {
    width: 440px;
  }
  .primary {
    background-color: #409eff;
    border-color: #409eff;
    border-radius: 0;
    color: #fff;
  }
}
</style>
